import { CampaignCard } from '@/features/campaign-card';
import { Campaign, useGetAllCampaignsQuery } from '@/models/campaign';
import { Placeholder } from './Placeholder';
import { Typography } from '@mui/material';
import { Trans } from 'react-i18next';
import { Button } from '@/components/Button';
import { NavLink } from 'react-router';
import AddIcon from '@mui/icons-material/Add';

export const Campaigns = () => {
  const { data, isLoading } = useGetAllCampaignsQuery();

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-4">
        <Typography variant="h4" fontWeight={500}>
          <Trans i18nKey="page.campaigns.title" />
        </Typography>
        <NavLink to="/client/create/ad">
          <Button variant="contained" color="secondary" startIcon={<AddIcon />}>
            <Trans i18nKey="ads.create_ad_text" />
          </Button>
        </NavLink>
      </div>

      {isLoading && <Placeholder size={8} />}

      {!isLoading && (
        <div className="flex flex-wrap w-full mb:basis-1/2 lg:basis-1/3 xl:basis-1/4 basis-full">
          {data?.map((it: Campaign) => (
            <CampaignCard
              key={it.id}
              id={it.id}
              title={it.title}
              heroImage={it.heroImage}
              description={it.description}
              gradientPlaceholder={it.gradientPlaceholder}
            />
          ))}
        </div>
      )}
    </div>
  );
};
